import DeviceSummary from "./DeviceSummaryContainer";

export default DeviceSummary;
